import Swiper, { Navigation, Pagination, Lazy, Grid } from 'swiper';
// Let op: zorg in je bundel ook voor de CSS-imports:
// import 'swiper/css';
// import 'swiper/css/grid';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

document.querySelectorAll('.models-carrousel').forEach((carousel) => {
  const el = carousel.querySelector('.swiper');
  const nextEl = carousel.querySelector('.swiper-button-next');
  const prevEl = carousel.querySelector('.swiper-button-prev');
  const paginationEl = carousel.querySelector('.swiper-pagination');
  if (!el || !nextEl || !prevEl || !paginationEl) return;

  const slidesCount = el.querySelectorAll('.swiper-wrapper .swiper-slide').length;
  const GUTTER = 10; // match deze met je CSS --gutter

  const swiper = new Swiper(el, {
    modules: [Navigation, Pagination, Lazy, Grid],
    preloadImages: false,
    lazy: { loadPrevNext: true, loadPrevNextAmount: 2 },
    rewind: true,
    watchOverflow: true,

    spaceBetween: GUTTER, // tussenruimte tussen tegels (horizontaal + verticaal in grid)
    navigation: { nextEl, prevEl },
    pagination: { el: paginationEl, clickable: true },

    // MOBIEL (<640px): 2 kolommen × max 4 rijen = tot 8 zichtbaar
    slidesPerView: 2,
    grid: { rows: Math.min(4, Math.ceil(slidesCount / 2)), fill: 'row' },
    slidesPerGroup: Math.min(8, slidesCount), // swipe per pagina van 8

    // BREAKPOINTS
    breakpoints: {
      // ≥640px: 2 rijen × 4 kolommen = 8 zichtbaar
      640: {
        slidesPerView: 4,
        grid: { rows: 2, fill: 'row' },
        slidesPerGroup: Math.min(8, slidesCount),
      },
      // ≥1024px: 1 rij, max 7 zichtbaar (pas aan naar wens)
      1024: {
        slidesPerView: slidesCount >= 8 ? 4 : Math.min(slidesCount, 7),
        grid: {
          rows: slidesCount >= 8 ? 2 : 1,
          fill: 'row',
        },
        slidesPerGroup: slidesCount >= 8 ? 8 : Math.min(slidesCount, 7),
      },
    },
  });

  // Fallback voor Swiper v6/v7 (oude grid-API) om per RIJ te vullen
  const p = swiper.params;
  if (p && !p.grid) {
    // alleen wanneer nieuwe grid niet bestaat (oude versie)
    swiper.params.slidesPerColumn = Math.min(4, Math.ceil(slidesCount / 2));
    swiper.params.slidesPerColumnFill = 'row';
    swiper.update();
  }
});